import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, getSubsite } from '../reducers/auth';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import LogoService from "../services/logo.service";
import { resolveImageUrl, resolveSwatchUrl } from '../utils/imageUrl';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const Product = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const [imgSrc, setImgSrc] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  const currentSubsite = useSelector(getSubsite);



  var currentLogo = {};
  var logoPrice = 0;
  var displayedColor = {};

  const colors = props.product.colors || [];
  const logos = props.product.logos || [];

  for (var i = 0; i < colors.length; i++) {
    if (colors[i].colorId === props.product.currentColor) {
      displayedColor = colors[i];
    }
  }

  const imageOver = (item) => {
    setImgSrc(item.modelImage);
    setCurrentColor(item);
    for (var i = 0; i < logos.length; i++) {
      currentLogo = logos[i];
    }
  }

  let featuredColor = null;
  if (props.product.featuredColor != null && colors.length > 0) {
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].colorId === props.product.featuredColor) {
        featuredColor = colors[i];
        for (var j = 0; j < logos.length; j++) {
          if (featuredColor.colorId === logos[j].colorId) {
            currentLogo = logos[j];
            break;
          }
        }
      }
    }
  }

  if (featuredColor === null && colors.length > 0) {
    featuredColor = colors[0];
    for (var i = 0; i < logos.length; i++) {
      if (colors[0].colorId === logos[i].colorId) {
        currentLogo = logos[i];
        break;
      }
    }
  }

  // If no colors available, return null to avoid render errors
  if (!featuredColor) {
    return null;
  }

  var imageUrl = "";
  if (featuredColor.modelImage) {
    if (featuredColor.modelImage.includes("uploads")) {
      imageUrl = apiUrl + featuredColor.modelImage;
    } else if (featuredColor.modelImage.startsWith("Images") || /^https?:\/\//i.test(featuredColor.modelImage)) {
      imageUrl = resolveImageUrl(featuredColor.modelImage);
    } else if (props.baseUrl) {
      imageUrl = props.baseUrl + featuredColor.modelImage;
    } else {
      imageUrl = featuredColor.modelImage;
    }
  }

  console.log("PRODUCT", props.product);
  console.log("PRODUCT userCapability", props.product?.userCapability);
  for (var i = 0; i < props.product?.logos?.length; i++) {
    logoPrice += props.product?.logos[i]?.decoration_logo?.price ? props.product?.logos[i]?.decoration_logo?.price : 0;
  }

  const itemClicked = () => {
    navigate(`../product/details/${props.product.id}`, { state: { productId: props.product.id, colorId: currentColor?.colorId }, replace: false });
  }

  return (
    <Col xs={12} sm={6} md={4} lg={3} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
      <div className="product" onClick={() => { navigate(`../product/details/${props.product.id}`, { state: { productId: props.product.id, colorId: currentColor?.colorId }, replace: false }); }}>
        <Container>
          <Row>
            <Col>
              {props.product.updatedAt && props.product.markAsNew == null && (
                 new Date(props.product.updatedAt).getTime() + ((24*60*60*1000) * (currentSubsite.newDayLimit ? currentSubsite.newDayLimit : 60)) > new Date().getTime() ? (
                  <div className="new-product">New Item</div>
                ) : (
                  null
                )
              )}
              {props.product.userCapability && (
                <div className="capability-banner">{props.product.userCapability.capabilityTitle || props.product.userCapability.capabilityName}</div>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="main-image-container modelImage">
                <div style={{ display: "inline-block", position: "relative" }}>
                  <Image className="modelImageImg" src={resolveImageUrl(displayedColor?.modelImage)} fluid ></Image>
                  {props.product?.logos && props.product?.logos?.map(logo => (
                    <div style={{position: "absolute", height: logo.width + '%', width: logo.width + '%', left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)'}}>
                    <img style={{position: "absolute", top: 0, left:0}} width={"100%"} src={apiUrl + LogoService.getThumbUrl(logo.decoration_logo.imageUrl, "xs")} />
                    </div>
                  ))}
                </div>
              </div>
            </Col>

          </Row>
          <Row>
            <Col>
              <div className="title">{props.product.title}</div>
            </Col>

          </Row>
          <Row>
            <Col>
              {loginStatus && (currentSubsite.paymentOptions && currentSubsite.paymentOptions != "itemlimit") && (
                <>
                  {/* Flat pricing (default) */}
                  {(!props.product.pricingType || props.product.pricingType === PRICING_TYPES.FLAT) && (
                    <div className="price">
                      ${(props.product.costSingle2X + logoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                    </div>
                  )}
                  {/* Quantity pricing */}
                  {props.product.pricingType === PRICING_TYPES.QUANTITY && (
                    <div className="price" style={{ fontSize: '0.9em' }}>
                      Quantity Pricing
                    </div>
                  )}
                  {/* Bill later pricing */}
                  {props.product.pricingType === PRICING_TYPES.BILL_LATER && (
                    <div className="price" style={{ color: '#666', fontStyle: 'italic' }}>
                      Billed Later
                    </div>
                  )}
                </>
              )}
              {!props.featured && (<>
                <div className="colors">
                  <div style={{ width: "100%", textAlign: "center" }}>
                    {props.product.colorCount} Colors available
                  </div>
                </div>
                <div className="colors">
                  {props.product.colors.map(color => (
                    <div className="color-swatch" key={"color" + color.colorId}>
                      {color.hexColor && color.hexColor != "" && !(color.colorImage && color.colorImage != "") && (
                        <div style={{ backgroundColor: color.hexColor, width: 20, height: 20 }}></div>
                      )}
                      {color.colorImage && color.colorImage != "" && (
                        <img src={resolveSwatchUrl(color.colorImage)} height={20} />
                      )}
                    </div>
                  ))}
                </div>
              </>
              )}

            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );
};

export default Product;